module.exports = __webpack_public_path__ + "static/img/Bachelor_010658a.682687f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010658a.jpg
// module id = 203
// module chunks = 0